import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Menu, X, Facebook, Instagram, MessageCircle, Star } from 'lucide-react';
import { useCart } from '../context/CartContext';

export const Navbar = () => {
  const { getTotalItems } = useCart();
  const [isOpen, setIsOpen] = React.useState(false);

  const navLinks = [
    { name: 'Inicio', path: '/' },
    { name: 'Productos', path: '/products' },
    { name: 'Acerca de', path: '/about' },
    { name: 'Contacto', path: '/contact' },
  ];

  return (
    <nav className="fixed top-0 w-full z-50 flex flex-col shadow-lg">
      {/* Top Announcement Bar */}
      <div className="bg-gradient-to-r from-[#FF6B00] to-[#FFD700] text-white py-2 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex justify-between items-center text-sm font-fredoka font-bold tracking-wide">
          <div className="flex items-center space-x-4">
            <a href="https://www.facebook.com/profile.php?id=100063210100576" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform">
              <Facebook size={18} />
            </a>
            <a href="https://www.instagram.com/jugueteria_diversytoys/" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform">
              <Instagram size={18} />
            </a>
            <a href="https://wa.me/573146758677" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform">
              <MessageCircle size={18} />
            </a>
            <a href="https://www.google.com/maps/place/Jugueter%C3%ADa+DIVERSYTOYS/@6.1534721,-75.3749534,17z/data=!3m1!4b1!4m6!3m5!1s0x8e469fa08aae6d1b:0x912abb9aa8437bc7!8m2!3d6.1534668!4d-75.3723785!16s%2Fg%2F11xsgbhm7f?entry=ttu&g_ep=EgoyMDI2MDQyNi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform" title="Google Maps">
              <Star size={18} />
            </a>
          </div>
          <div className="text-center flex-1 mx-4 animate-pulse">
            ¡Aprovecha nuestras increíbles ofertas en juguetes! 🚀
          </div>
          <div className="hidden sm:block">
            Envíos a todo el país 🇨🇴
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <div className="bg-white/95 backdrop-blur-md border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center" data-testid="nav-logo-link">
            <img
              src="/logo.png"
              alt="Diversytoys Logo"
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-[#1A1A2E] hover:text-[#00C2CB] font-quicksand font-semibold transition-colors duration-300"
                data-testid={`nav-link-${link.name.toLowerCase()}`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/cart"
              className="relative bg-[#FF6B00] text-white px-6 py-3 rounded-full font-fredoka font-bold hover:bg-[#FF6B00]/90 hover:scale-105 transition-all duration-300 shadow-lg"
              data-testid="nav-cart-button"
            >
              <ShoppingCart className="inline-block w-5 h-5 mr-2" />
              Carrito
              {getTotalItems() > 0 && (
                <span className="absolute -top-2 -right-2 bg-[#FFD700] text-[#3D2E00] w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold" data-testid="cart-badge">
                  {getTotalItems()}
                </span>
              )}
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-[#1A1A2E] p-2"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 space-y-3 bg-white" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className="block text-[#1A1A2E] hover:text-[#00C2CB] font-quicksand font-semibold py-2 px-4"
                data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}
              >
                {link.name}
              </Link>
            ))}
            <div className="px-4 pb-2">
              <Link
                to="/cart"
                onClick={() => setIsOpen(false)}
                className="block bg-[#FF6B00] text-white px-6 py-3 rounded-full font-fredoka font-bold text-center"
                data-testid="mobile-nav-cart-button"
              >
                <ShoppingCart className="inline-block w-5 h-5 mr-2" />
                Carrito ({getTotalItems()})
              </Link>
            </div>
          </div>
        )}
        </div>
      </div>
    </nav>
  );
};